module.exports = __webpack_public_path__ + "img/Quiet-Cove-018.0051a283.jpg";